import { render } from "./FakeLogicPropsCmp.vue?vue&type=template&id=395f7c72"
import script from "./FakeLogicPropsCmp.vue?vue&type=script&lang=js"
export * from "./FakeLogicPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__